import { SigningChecklistOrderState } from '@/store/modules/signing-checklist-order/state'

export const getters: StoreGetters<SigningChecklistOrderState> = {
  signatureGroupsEditionPending: (state): boolean =>
    state.signatureGroupCreationPending ||
    state.signatureGroupDeletionPending ||
    state.signatureGroupMovingPending ||
    state.signatureStepDeletionPending ||
    state.signatureStepMovingPending,
}
